import React, { useEffect, useState } from "react";
import { Button, Col, Row, Form, Table } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router";
import {
  editPermission,
  editRole,
  fetchPermission,
  selectLoading,
  selectPermission,
} from "./userSlice";
// import { editItem } from "./userroleSlice";
import { showSuccessDialog, showErrorDialog } from "../../utility";
import LoadingFetchData from "../../utility/LoadingFetchData";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
// MUI
import {
  fade,
  withStyles,
  makeStyles,
  createMuiTheme,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { red } from "@material-ui/core/colors";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { goBack } from "react-router-redux";

const useStylesReddit = makeStyles((theme) => ({
  root: {
    border: "1px solid #e2e2e1",
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "#FFFFFF",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover": {
      backgroundColor: "#fff",
    },
    "&$focused": {
      backgroundColor: "#fff",
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main,
    },
  },
  focused: {},
}));

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export const PermissionEdit = (params) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const dataPermission = useSelector(selectPermission);
  const loading = useSelector(selectLoading);

  const [permissionData, setPermissionData] = useState([]);
  const [overlayLoading, setOverlayLoading] = useState(false);
  const { id } = useParams();

  const name = params.location.state;

  const [desc, setDesc] = useState(name.params);

  console.log(desc, "asd'as");

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load
      await dispatch(fetchPermission(id));
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataPermission != null) {
      setPermissionData(dataPermission);
    }
  }, [dataPermission]);

  const handleSave = async () => {
    const params = {
      role_id: id,
      role_description: desc,
    };
    let temp = [];

    permissionData.forEach((menu) => {
      if (menu.childs.length === 0) {
        // menu without child
        temp = [...temp, ...menu.permissions];
      } else {
        // menu with childs

        temp = [...temp, ...menu.permissions];

        menu.childs.map((submenu) => {
          if (submenu.childs.length === 0) {
            // submenu without childs

            temp = [...temp, ...submenu.permissions];
          } else {
            // submenu with childs
            temp = [...temp, ...submenu.permissions];

            submenu.childs.map((child) => {
              if (child.childs.length === 0) {
                // child without childs

                temp = [...temp, ...child.permissions];
              } else {
                // child with childs
                temp = [...temp, ...child.permissions];

                child.childs.map((lastchild) => {
                  // child
                  temp = [...temp, ...lastchild.permissions];
                });
              }
            });
          }
        });
      }
    });

    let _temp = [...temp];

    const initData = _temp.map((item, index) => {
      return {
        userp_id: item.userp_id,
        role_description: item.role_description,
        menu_id: item.menu_id,
        permission_code: item.permission_code,
        permission_value: item.permission_value,
      };
    });

    // await callApiRole(params);

    try {
      const response = await dispatch(editRole(params));
      if (response.payload.status === 200) {
        try {
          const response = await dispatch(editPermission(initData));
          if (response.payload.status === 200) {
            const action = await showSuccessDialog(
              response.payload.data.message
            );
            if (action.isConfirmed) history.goBack();
          } else {
            showErrorDialog(response.payload.data.message);
          }
        } catch (error) {
          console.log(error.message);
        }
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const callApiRole = async (params) => {
    try {
      const response = await dispatch(editRole(params));
      if (response.payload.status === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <Card>
      <LoadingFetchData active={overlayLoading} />

      <CardHeader title="Role">
        <CardHeaderToolbar>
          <Button
            className="primary"
            onClick={() => history.push("/administration/management-user/role")}
          >
            Back To List
          </Button>
        </CardHeaderToolbar>
      </CardHeader>

      <CardBody>
        <Form className="mb-5">
          <Form.Group as={Row}>
            <Col sm={5}>
              <RedditTextField
                label="Role Name*"
                className={classes.margin}
                variant="filled"
                id="reddit-input"
                size="small"
                fullWidth
                value={desc}
                onChange={(e) => {
                  setDesc(e.target.value);
                }}
              />
            </Col>

            <Col sm={1}>
              <Button
                variant="primary"
                className="mr-3 mt-3"
                onClick={handleSave}
              >
                Save
              </Button>
            </Col>
          </Form.Group>
        </Form>

        {permissionData && permissionData.length > 0 ? (
          <Table striped bordered>
            <thead style={{ backgroundColor: "#0D1967", textAlign: "center" }}>
              <tr style={{ textAlign: "center" }}>
                <th className="text-white">Menu </th>
                <th className="text-white">Actions</th>
                <th className="text-white">All</th>
              </tr>
            </thead>
            <tbody>
              {/* Table User Access */}
              {/* Looping Menu Content */}
              {permissionData &&
                permissionData.map((menu, i) => {
                  if (menu.childs && menu.childs.length === 0) {
                    // Menu without child
                    return (
                      <MenuLevel1
                        data={permissionData}
                        updateData={setPermissionData}
                        obj={menu}
                        i={i}
                      />
                    );
                  } else {
                    // Menu with child
                    return (
                      <>
                        <MenuLevel1
                          data={permissionData}
                          updateData={setPermissionData}
                          obj={menu}
                          i={i}
                        />
                        {/* Looping Submenu Content */}
                        {menu.childs.map((submenu, j) => {
                          if (submenu.childs && submenu.childs.length === 0) {
                            // Submenu without child
                            return (
                              <MenuLevel2
                                data={permissionData}
                                updateData={setPermissionData}
                                obj={submenu}
                                i={i}
                                j={j}
                              />
                            );
                          } else {
                            // Submenu with child
                            return (
                              <>
                                <MenuLevel2
                                  data={permissionData}
                                  updateData={setPermissionData}
                                  obj={submenu}
                                  i={i}
                                  j={j}
                                />
                                {/* Looping Child Content lvl 3 */}
                                {submenu.childs.map((child, k) => {
                                  if (
                                    child.childs &&
                                    child.childs.length === 0
                                  ) {
                                    // Submenu without child
                                    return (
                                      <MenuLevel3
                                        data={permissionData}
                                        updateData={setPermissionData}
                                        obj={child}
                                        i={i}
                                        j={j}
                                        k={k}
                                      />
                                    );
                                  } else {
                                    // Submenu with child
                                    return (
                                      <>
                                        <MenuLevel3
                                          data={permissionData}
                                          updateData={setPermissionData}
                                          obj={child}
                                          i={i}
                                          j={j}
                                          k={k}
                                        />
                                        {/* Looping Child Content lvl 3 */}

                                        {child.childs.map((lastchild, l) => {
                                          return (
                                            <MenuLevel4
                                              data={permissionData}
                                              updateData={setPermissionData}
                                              obj={lastchild}
                                              i={i}
                                              j={j}
                                              k={k}
                                              l={l}
                                            />
                                          );
                                        })}
                                      </>
                                    );
                                  }
                                  // return (
                                  //   <MenuLevel3
                                  //     data={permissionData}
                                  //     updateData={setPermissionData}
                                  //     obj={child}
                                  //     i={i}
                                  //     j={j}
                                  //     k={k}
                                  //   />
                                  // );
                                })}
                              </>
                            );
                          }
                        })}
                      </>
                    );
                  }
                })}
            </tbody>
          </Table>
        ) : null}
      </CardBody>
    </Card>
  );
};

const isActive = (value) => (value === 1 ? true : false);

const isAllCheck = (obj) => {
  var activePermissions = obj.permissions.filter(
    (obj) => obj.permission_value === 1
  );

  return activePermissions.length === obj.permissions.length ? true : false;
};

const MenuLevel1 = ({ data, updateData, obj, i }) => {
  return (
    <tr>
      <td>
        <label>
          <b>
            - {obj.menu_name.toUpperCase()}
            {obj.menu_mobile === "Y" ? " - Mobile" : ""}
          </b>
        </label>
      </td>
      <td>
        {obj.permissions.map((permission, idx) => {
          return (
            <label className="mr-4 ">
              <input
                type="checkbox"
                className="mr-3 mt-3"
                checked={isActive(permission.permission_value)}
                onChange={(e) => {
                  let temp = JSON.parse(JSON.stringify(data));

                  if (temp[i].permissions[idx].permission_value === 0) {
                    temp[i].permissions[idx].permission_value = 1;
                  } else {
                    temp[i].permissions[idx].permission_value = 0;
                  }

                  updateData(temp);
                }}
              />
              <b className="pr-4">{permission.permission_code}</b>
            </label>
          );
        })}
      </td>

      <td>
        <label className="mr-4 ">
          <input
            type="checkbox"
            className="mr-3 mt-3"
            checked={isAllCheck(obj)}
            onChange={(e) => {
              let updateObj;
              if (isAllCheck(obj)) {
                // uncheck all
                console.log("uncheck");
                updateObj = obj.permissions.map((el) => {
                  return {
                    ...el,
                    permission_value: 0,
                  };
                });
              } else {
                // check all
                console.log("check");

                updateObj = obj.permissions.map((el) => {
                  return {
                    ...el,
                    permission_value: 1,
                  };
                });
              }

              let temp = JSON.parse(JSON.stringify(data));

              temp[i].permissions = updateObj;
              updateData(temp);
            }}
          />
          <b className="pr-4">ALL </b>
        </label>
      </td>
    </tr>
  );
};

const MenuLevel2 = ({ data, updateData, obj, i, j }) => {
  return (
    <tr>
      <td>
        <label>
          <b>
            -- {obj.menu_name.toUpperCase()}{" "}
            {obj.menu_mobile === "Y" ? " - Mobile" : ""}
          </b>
        </label>
      </td>
      <td>
        {obj.permissions.map((permission, idx) => {
          return (
            <label className="mr-4 ">
              <input
                type="checkbox"
                className="mr-3 mt-3"
                checked={isActive(permission.permission_value)}
                onChange={(e) => {
                  let temp = JSON.parse(JSON.stringify(data));

                  if (
                    temp[i].childs[j].permissions[idx].permission_value === 0
                  ) {
                    temp[i].childs[j].permissions[idx].permission_value = 1;
                  } else {
                    temp[i].childs[j].permissions[idx].permission_value = 0;
                  }

                  updateData(temp);
                }}
              />
              <b className="pr-4">{permission.permission_code}</b>
            </label>
          );
        })}
      </td>

      <td>
        <label className="mr-4 ">
          <input
            type="checkbox"
            className="mr-3 mt-3"
            checked={isAllCheck(obj)}
            onChange={(e) => {
              let updateObj;
              if (isAllCheck(obj)) {
                console.log("lvel2", obj);
                // uncheck all
                console.log("uncheck");
                updateObj = obj.permissions.map((el) => {
                  return {
                    ...el,
                    permission_value: 0,
                  };
                });
              } else {
                // check all
                console.log("check");

                updateObj = obj.permissions.map((el) => {
                  return {
                    ...el,
                    permission_value: 1,
                  };
                });
              }

              let temp = JSON.parse(JSON.stringify(data));

              temp[i].childs[j].permissions = updateObj;
              updateData(temp);
            }}
          />
          <b className="pr-4">ALL</b>
        </label>
      </td>
    </tr>
  );
};

const MenuLevel3 = ({ data, updateData, obj, i, j, k }) => {
  return (
    <tr>
      <td>
        <label>
          <b>
            --- [{obj.menu_name.toUpperCase()}]{" "}
            {obj.menu_mobile === "Y" ? " - Mobile" : ""}
          </b>
        </label>
      </td>
      <td>
        {obj.permissions.map((permission, idx) => {
          return (
            <label className="mr-4 ">
              <input
                type="checkbox"
                className="mr-3 mt-3"
                checked={isActive(permission.permission_value)}
                onChange={(e) => {
                  let temp = JSON.parse(JSON.stringify(data));

                  if (
                    temp[i].childs[j].childs[k].permissions[idx]
                      .permission_value === 0
                  ) {
                    temp[i].childs[j].childs[k].permissions[
                      idx
                    ].permission_value = 1;
                  } else {
                    temp[i].childs[j].childs[k].permissions[
                      idx
                    ].permission_value = 0;
                  }

                  updateData(temp);
                }}
              />
              <b className="pr-4">{permission.permission_code}</b>
            </label>
          );
        })}
      </td>

      <td>
        <label className="mr-4 ">
          <input
            type="checkbox"
            className="mr-3 mt-3"
            checked={isAllCheck(obj)}
            onChange={(e) => {
              let updateObj;
              if (isAllCheck(obj)) {
                // uncheck all
                console.log("uncheck");
                updateObj = obj.permissions.map((el) => {
                  return {
                    ...el,
                    permission_value: 0,
                  };
                });
              } else {
                // check all
                console.log("check");

                updateObj = obj.permissions.map((el) => {
                  return {
                    ...el,
                    permission_value: 1,
                  };
                });
              }

              let temp = JSON.parse(JSON.stringify(data));

              temp[i].childs[j].childs[k].permissions = updateObj;
              updateData(temp);
            }}
          />
          <b className="pr-4">ALL</b>
        </label>
      </td>
    </tr>
  );
};
const MenuLevel4 = ({ data, updateData, obj, i, j, k, l }) => {
  return (
    <tr>
      <td>
        <label>
          <b>
            ---- [{obj.menu_name.toUpperCase()}{" "}
            {obj.menu_mobile === "Y" ? " - Mobile" : ""}]
          </b>
        </label>
      </td>
      <td>
        {obj.permissions.map((permission, idx) => {
          return (
            <label className="mr-4 ">
              <input
                type="checkbox"
                className="mr-3 mt-3"
                checked={isActive(permission.permission_value)}
                onChange={(e) => {
                  let temp = JSON.parse(JSON.stringify(data));

                  if (
                    temp[i].childs[j].childs[k].childs[l].permissions[idx]
                      .permission_value === 0
                  ) {
                    temp[i].childs[j].childs[k].childs[l].permissions[
                      idx
                    ].permission_value = 1;
                  } else {
                    temp[i].childs[j].childs[k].childs[l].permissions[
                      idx
                    ].permission_value = 0;
                  }

                  updateData(temp);
                }}
              />
              <b className="pr-4">{permission.permission_code}</b>
            </label>
          );
        })}
      </td>

      <td>
        <label className="mr-4 ">
          <input
            type="checkbox"
            className="mr-3 mt-3"
            checked={isAllCheck(obj)}
            onChange={(e) => {
              let updateObj;
              if (isAllCheck(obj)) {
                // uncheck all
                console.log("uncheck");
                updateObj = obj.permissions.map((el) => {
                  return {
                    ...el,
                    permission_value: 0,
                  };
                });
              } else {
                // check all
                console.log("check");

                updateObj = obj.permissions.map((el) => {
                  return {
                    ...el,
                    permission_value: 1,
                  };
                });
              }

              let temp = JSON.parse(JSON.stringify(data));

              temp[i].childs[j].childs[k].childs[l].permissions = updateObj;
              updateData(temp);
            }}
          />
          <b className="pr-4">ALL</b>
        </label>
      </td>
    </tr>
  );
};
